
























import {Dialog} from 'vant';


export default {
  name: "passwordErrorPrompt",
  props: {
    errCode: {
      type: Number
    },
    errHtml: {
      type: String,
      defaults: ``
    }
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      show: true,
      dialogOptions: {
        dialogConfirmButtonText: "",
      }
    }
  },
  created() {
    (this as any).errCodeHandle();
  },
  watch: {
    errCode(oldV, newV) {
      (this as any).errCodeHandle();
    }
  },
  computed:{
    bgColorDialog(){
      return (this as any).$store.getters["common/bgColor"] == 'black-theme' ? 'black-theme-dialog' : ''
    }
  },
  methods: {
    errCodeHandle() {
      switch ((this as any).errCode) {
        case 100173:
          (this as any).dialogOptions.dialogConfirmButtonText = (this as any).$t("passwordErrorPrompt.tryAgain");
          break;
        case 100174:
          (this as any).dialogOptions.dialogConfirmButtonText = (this as any).$t("passwordErrorPrompt.set");
          break;
        default:
          break;
      }
    },
    dialogConfirm() {
      (this as any).$emit("password-error-prompt-confirm", (this as any).errCode);
      (this as any).show = true;
      switch ((this as any).errCode) {
        case 100173:
          break;

        case 100174:
          (this as any).$router.push({
            path: "/login-password-forget"
          });
          break;

        default:
          break;
      }
    }
  }
}
